const WALLETITEM = [
  {
    id:'1',
    name:'에르메스지갑1',
    price:1200000,
    date: "2024-12-20",
    img: require('../assets/images/wallet_item.png'),
    sellCount:10,
    delivery:0
  },
  {
    id:'2',
    name:'에르메스지갑2',
    price:1200000,
    date: "2024-12-19",
    img: require('../assets/images/wallet_item.png'),
    sellCount:20,
    delivery:0
  },
  {
    id:'3',
    name:'에르메스지갑3',
    price:'100000',
    date: "2024-12-18",
    img: require('../assets/images/wallet_item.png'),
    sellCount:30,
    delivery:0
  },
  {
    id:'4',
    name:'에르메스지갑4',
    price:'1,000,000',
    date: "2024-12-17",
    img: require('../assets/images/wallet_item.png'),
    sellCount:40,
    delivery:0
  },
  {
    id:'5',
    name:'에르메스지갑5',
    price:1200000,
    date: "2024-12-17",
    img: require('../assets/images/wallet_item.png'),
    sellCount:50
  },
  {
    id:'6',
    name:'에르메스지갑6',
    price:1200000,
    date: "2024-12-17",
    img: require('../assets/images/wallet_item.png'),
    sellCount:60,
    delivery:0
  },
]

export default WALLETITEM;